import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BuyTokens = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to subscribe page - BuyTokens is deprecated
    navigate('/subscribe', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a1628] flex items-center justify-center">
      <p className="text-gray-400">Redirecting to Subscribe...</p>
    </div>
  );
};

export default BuyTokens;
